import * as EventEmitter from 'eventemitter3';
import { DEFAULT_BPM } from '../data/Config';
import { SignalSource } from '../data/SignalSource';

export enum MotionSourceType {
  Soundtrack = 'soundtrack',
  Beat = 'beat',
  Binary = 'binary',
  LinearLoop = 'linear-loop',
  FullOn = 'full-on'
}

export class MotionSource extends EventEmitter {
  hasAudio: boolean = false;
  isPlaying: boolean = false;
  loopsCount: number = 1;
  endCallback: Function | null = null;
  type: MotionSourceType = MotionSourceType.Beat;

  protected _bpm: number = DEFAULT_BPM;

  get bpm(): number {
    return this._bpm;
  }
  set bpm(v: number) {
    this._bpm = v;
  }

  reset() {
    console.error('MotionSource.reset should be overridden by the subclass');
  }

  play() {
    console.error('MotionSource.play should be overridden by the subclass');
  }

  resume() {
    console.error('MotionSource.resume should be overridden by the subclass');
  }

  pause() {
    console.error('MotionSource.pause should be overridden by the subclass');
  }

  isCustom(): boolean {
    console.error('MotionSource.isCustom should be overridden by the subclass');
    return false;
  }

  // millist
  getDuration(): number {
    console.error(
      'MotionSource.getDuration should be overridden by the subclass'
    );
    return 0;
  }

  getLoopDuration(): number {
    return this.getDuration();
  }

  jumpTo(millis: number) {
    console.error('MotionSource.jumpTo should be overridden by the subclass');
  }

  // milliseconds
  getCurrentTime(): number {
    console.error(
      'MotionSource.getCurrentTime should be overridden by the subclass'
    );
    return 0;
  }

  getVideoCurrentTime(): number {
    return this.getCurrentTime();
  }

  getLevel(signal: SignalSource = SignalSource.Default): number {
    console.error('MotionSource.getLevel should be overridden by the subclass');
    return 0;
  }

  getLevelAt(
    millis: number,
    signal: SignalSource = SignalSource.Default
  ): number {
    return 0;
  }

  getNormalisedPosition(): number {
    return Math.max(0, Math.min(1, this.getCurrentTime() / this.getDuration()));
  }

  update() {
    // optional override
  }

  dispose() {
    // optional override
  }
}



// WEBPACK FOOTER //
// ./src/motion/MotionSource.ts